import type { QueryClient } from '@tanstack/react-query';
import { uniqBy } from 'lodash-es';
import queryKeysCreatives from '../../creatives/api/queryKeys';
import type { CreativesByHypothesis } from 'features/creatives';
import type { CreativeEntry } from 'types/shared';
import queryKeys from '../api/queryKeys';
import type { AdSetEntry } from '../api/getAdSets';

export interface FacebookAdSubmitContext {
  creativesById: Map<string, CreativeEntry>;
  cachedAdSets: AdSetEntry[];
}

export const buildFacebookAdSubmitContext = (
  queryClient: QueryClient,
): FacebookAdSubmitContext => {
  const cachedCreativesData = [
    ...queryClient
      .getQueryCache()
      .findAll({ queryKey: queryKeysCreatives.allCreatives })
      .flatMap((query) => query.state.data as CreativeEntry[])
      .filter((creative) => !!creative),
    ...queryClient
      .getQueryCache()
      .findAll({ queryKey: queryKeysCreatives.allCreativesWithHypothesis })
      .flatMap((query) =>
        Object.values(
          (query.state.data as CreativesByHypothesis | undefined) ?? {},
        ).flat(),
      )
      .filter((creative) => !!creative),
  ];

  const creativesById = new Map<string, CreativeEntry>();
  cachedCreativesData.forEach((creative) => {
    creativesById.set(String(creative.id), creative);
  });

  const cachedAdSets = queryClient
    .getQueryCache()
    .findAll({ queryKey: queryKeys.adSets })
    .flatMap((query) => query.state.data as AdSetEntry[])
    .filter((adSet) => !!adSet);

  return {
    creativesById,
    cachedAdSets: uniqBy(cachedAdSets, 'id'),
  };
};
